import { useEffect, useState } from "react";

export default function AgeGate({ content }) {
  const ag = content?.age_gate || {};
  const [status, setStatus] = useState("checking"); // checking | show | ok | blocked

  useEffect(() => {
    const confirmed = localStorage.getItem("age_confirmed") === "true";
    setStatus(confirmed ? "ok" : "show");
  }, []);

  useEffect(() => {
    if (status === "show" || status === "blocked") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [status]);

  const confirm = () => {
    localStorage.setItem("age_confirmed", "true");
    setStatus("ok");
  };

  const decline = () => {
    const url = ag.decline_redirect_url;
    if (url) {
      try { window.location.href = url; return; } catch (e) {}
    }
    setStatus("blocked");
  };

  if (status === "ok" || status === "checking") return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-5"
      style={{ background: "rgba(6,4,10,0.86)", backdropFilter: "blur(10px)" }}
      role="dialog"
      aria-modal="true"
      data-testid="age-gate"
    >
      <div className="glass max-w-md w-full text-center" style={{ padding: "2.4rem 1.8rem" }}>
        {status === "show" ? (
          <>
            <h2 className="font-head text-2xl sm:text-3xl font-bold mb-4">{ag.title}</h2>
            <p className="mb-8" style={{ color: "var(--text-sec)" }}>{ag.text}</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button className="btn-grad px-7 py-3.5 flex-1" onClick={confirm} data-testid="age-confirm-btn">
                {ag.confirm_text}
              </button>
              <button className="btn-ghost px-7 py-3.5 flex-1" onClick={decline} data-testid="age-decline-btn">
                {ag.decline_text}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="text-4xl mb-3" aria-hidden="true">🔒</div>
            <p className="text-lg" data-testid="age-blocked-text">{ag.blocked_text}</p>
          </>
        )}
      </div>
    </div>
  );
}
